const aaa = [
 
    {
        path: "rechargeOrderSee",
        component: () => import("@/views/dingdan/order/rechargeOrder/see.vue"),
        meta: { title: '订单' },
    },
   
    {
        path: "rechargeOrderList",
        component: () => import("@/views/dingdan/order/rechargeOrder/list.vue"),
        meta: { title: '订单', keepAlive: true },
    }

    

    
]
export default aaa;